import { ReactNode } from 'react';

export const Page = ({ children }: { children: ReactNode }) => {
  return <div className="flex flex-1 flex-col  p-4 px-[10vw] pb-6   md:p-9 md:px-[6.98vw] md:pb-12 ">{children}</div>;
};
